import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder } from '@angular/forms';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { Table } from 'primeng/table';
import { Tc, EnumIdsTcPais, EnumSiNoTodos, TcExpanded } from '../../../core/_infrastructure/types/common';
import { SelectItem } from 'primeng/api';
import {
    CertificadoSedeExportacionSLItemResultsViewModel,
    CertificadoSedeExportacionSLItemViewModel,
    FilterSearchingCertificadoSedeExporSLViewModel,
} from './certSedeExporSL.types';
import { CertificadoSedeExporSlService } from './certSedeExporSL.service';
import { catchError, of, tap } from 'rxjs';

@Component({
    selector: 'app-certSedeExporSL-list',
    templateUrl: './certSedeExporSL-list.component.html',
})
export class CertSedeExporSLListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;

    listSiNoTodos: SelectItem[];
    listPuntoInspeccion: Tc[];
    resultCertificadoSedeExporSl: CertificadoSedeExportacionSLItemResultsViewModel;
    cols: any[];
    firstDayMonth: Date;
    lastDayMonth: Date;
    listTipoSolicitud: TcExpanded[];

    visibilitySpinner: boolean = false;

    public isCollapsed = false;

    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private certificadoSedeExporSlService: CertificadoSedeExporSlService,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.resultCertificadoSedeExporSl = new CertificadoSedeExportacionSLItemResultsViewModel();
    }

    ngOnInit() {
        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            //{ field: 'Image', header: '' },
            { field: 'Codigo', header: 'Nº Solicitud' },
            { field: 'NumeroCertificado', header: 'Nº Certif. Fito' },
            { field: 'RefSolicitante', header: 'Ref. Solicitante' },
            { field: 'FechaEnvio', header: 'Fecha' }, // | date:'dd/MM/yyyy'
            { field: 'NombrePuntoInspeccion', header: 'Punto Inspección' },
            { field: 'NombreTipoSolicitud', header: 'Tipo Solicitud' },
            { field: 'Firmado', header: 'Firmado' },
        ];

        this.firstDayMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        let temp = new Date().getMonth() + 1;
        this.lastDayMonth = new Date(new Date(new Date().getFullYear(), temp, 1).getTime() - 0.001 * 60 * 60 * 24);

        this.form = this.fb.group({
            Codigo: '',
            IdTipoSolicitudEx: null,
            IdPuntoInspeccion: null,
            Firmado: EnumSiNoTodos.NO,
            RefSolicitante: '',
            FechaDesde: this.firstDayMonth,
            FechaHasta: this.lastDayMonth,
            NumeroCertificado: '',
        });

        this.globalService.getPuntoInspeccionByPais(EnumIdsTcPais.ID_ESPANA).subscribe(res => {
            this.listPuntoInspeccion = res;
        });
        this.globalService.getTipoSolicitudExporSl().subscribe(res => {
            this.listTipoSolicitud = res.filter(f => f.Codigo != 'C');
        });

        //p-selectButton
        this.listSiNoTodos = [
            { label: 'Sí', value: EnumSiNoTodos.SI },
            { label: 'NO', value: EnumSiNoTodos.NO },
            { label: 'TODOS', value: EnumSiNoTodos.TODOS },
        ];

        this.loadBack();
    }

    loadBack() {
        if (
            this.certificadoSedeExporSlService.currentFilterCertificadoSedeExpor.FechaDesde == null ||
            this.certificadoSedeExporSlService.currentFilterCertificadoSedeExpor.FechaHasta == null ||
            this.certificadoSedeExporSlService.currentFilterCertificadoSedeExpor.FechaDesde!.toString() != this.firstDayMonth.toString() ||
            this.certificadoSedeExporSlService.currentFilterCertificadoSedeExpor.FechaHasta!.toString() != this.lastDayMonth.toString() ||
            this.certificadoSedeExporSlService.currentFilterCertificadoSedeExpor.IdTipoSolicitudEx != null ||
            this.certificadoSedeExporSlService.currentFilterCertificadoSedeExpor.IdPuntoInspeccion != null ||
            this.certificadoSedeExporSlService.currentFilterCertificadoSedeExpor.Codigo != '' ||
            this.certificadoSedeExporSlService.currentFilterCertificadoSedeExpor.NumeroCertificado != '' ||
            this.certificadoSedeExporSlService.currentFilterCertificadoSedeExpor.RefSolicitante != '' ||
            this.certificadoSedeExporSlService.currentFilterCertificadoSedeExpor.Firmado != EnumSiNoTodos.NO
        ) {
            this.form.patchValue({
                FechaDesde: this.certificadoSedeExporSlService.currentFilterCertificadoSedeExpor.FechaDesde,
                FechaHasta: this.certificadoSedeExporSlService.currentFilterCertificadoSedeExpor.FechaHasta,
                IdPuntoInspeccion: this.certificadoSedeExporSlService.currentFilterCertificadoSedeExpor.IdPuntoInspeccion,
                IdTipoSolicitudEx: this.certificadoSedeExporSlService.currentFilterCertificadoSedeExpor.IdTipoSolicitudEx,
                Codigo: this.certificadoSedeExporSlService.currentFilterCertificadoSedeExpor.Codigo,
                NumeroCertificado: this.certificadoSedeExporSlService.currentFilterCertificadoSedeExpor.NumeroCertificado,
                RefSolicitante: this.certificadoSedeExporSlService.currentFilterCertificadoSedeExpor.RefSolicitante,
                HabilitadaImportacion: this.certificadoSedeExporSlService.currentFilterCertificadoSedeExpor.Firmado,
            });

            this.onSearchButton();
        }
    }

    onSearchButton() {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    CreateModel(): FilterSearchingCertificadoSedeExporSLViewModel {
        let model: FilterSearchingCertificadoSedeExporSLViewModel = new FilterSearchingCertificadoSedeExporSLViewModel();

        model.FechaDesde = this.form.value.FechaDesde;
        model.FechaHasta = this.form.value.FechaHasta;
        model.IdPuntoInspeccion = this.form.value.IdPuntoInspeccion;
        model.IdTipoSolicitudEx = this.form.value.IdTipoSolicitudEx;
        model.Codigo = this.form.value.Codigo;
        model.NumeroCertificado = this.form.value.NumeroCertificado;
        model.RefSolicitante = this.form.value.RefSolicitante;
        model.Firmado = this.form.value.Firmado;

        return model;
    }

    Search(pageNumber: number, asc: number = 0, orderBy: string = '') {
        let model: FilterSearchingCertificadoSedeExporSLViewModel = this.CreateModel();

        model.PageNumber = pageNumber;
        model.Asc = asc;
        model.OrderBy = orderBy;

        //Todo:agaro. 23/01/2020.
        //Establecer la hora de la fecha Hasta si tiene valor a las 23:59:59, que solo lo hace si no se selecciona y no se estaba teniendo
        //en cuenta el propio día de la fecha hasta.
        if (model.FechaHasta != null) {
            model.FechaHasta.setHours(23);
            model.FechaHasta.setMinutes(59);
            model.FechaHasta.setSeconds(59);
        }

        this.certificadoSedeExporSlService
            .postPagedByFilter(model)
            .pipe(
                tap(result => {
                    this.resultCertificadoSedeExporSl = result;
                    this.loading = false;
                }),
                catchError(error => {
                    this.catchServerError(error);
                    //this.form?.disable();
                    return of(null);
                }),
            )
            .subscribe();
    }

    onSearchLazy(event: any) {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;

        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    checkFirmado(item: CertificadoSedeExportacionSLItemViewModel) {
        return !item.Firmado;
    }

    onFirmaCF(item: CertificadoSedeExportacionSLItemViewModel) {
        this.certificadoSedeExporSlService.exportCertificadoFitosanitarioSilverlight(item.Id).subscribe({
            next: res => {
                this.OpenDownloadedFile(res);
                this.onSearchButton();
            },
            error: error => {
                this.catchServerError(error);
            },
        });
    }

    onCleanButton() {
        this.form.setValue({
            Codigo: '',
            NumeroCertificado: '',
            IdTipoSolicitudEx: null,
            IdPuntoInspeccion: null,
            Firmado: EnumSiNoTodos.NO,
            RefSolicitante: '',
            FechaDesde: this.firstDayMonth,
            FechaHasta: this.lastDayMonth,
        });

        this.searchingButton = false;
        this.isCollapsed = false;

        this.resultCertificadoSedeExporSl = new CertificadoSedeExportacionSLItemResultsViewModel();
    }

    onExportExcel() {
        this.visibilitySpinner = true;

        this.certificadoSedeExporSlService.export(this.CreateModel()).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinner = false;
        });
    }
}
